<mat-form-field floatLabel="never" appearance="outline" class="col-11 p-0" required>
  <input name="{{name}}" matInput placeholder="" style="color: #18181a;" [(ngModel)]="model" [formControl]="myControl"
    [maxlength]="maxLength" [matAutocomplete]="auto" [required]="required" [readonly]='disabled' (focusout)="setData($event)">
  <mat-hint align="end" style="margin: 10px 0;">{{model.length || 0}} / {{maxLength}}</mat-hint>
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name">
      {{option.name}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>